import React, { Component } from 'react';
import params from "./Params";
import harrenhal from "./Harrenhal";

const HW_DRIVER_URL = 'http://localhost:8001';

class HwStatus extends Component {

    // This method is called by React
    constructor(props) {
        super(props);
        this.state = {
            timer: null,
            isDriverConfigured: false,
            harrenhal_ver: null,
            scenarioState: 'unknown',
            sess_uuid: null,
            isDutRunning: false,
            sessionLog: ""
        };

        // Make sure when these callback are called their "this" points to the HwStatus class, not to the Window
        this.updateHwStatus = this.updateHwStatus.bind(this);
        this.startScenario = this.startScenario.bind(this);
        this.stopScenario = this.stopScenario.bind(this);
    }

    // This method is called by React
    componentDidMount() {
        let timer = setInterval(this.updateHwStatus, 1000);
        this.setState({
            timer: timer,
        });
    }

    // This method is called by React
    render() {
        let hwStatus;
        let harrenhalDownloadLink = process.env.PUBLIC_URL + harrenhal.HARRENHAL_LINK;
        if (this.props.id_token){
            if(this.state.isDriverConfigured){
                // Check the Harrenal version
                if( this.state.harrenhal_ver === harrenhal.HARRENHAL_VER){
                    if(this.state.scenarioState === 'idle') {
                        hwStatus = <div>
                            The Riverrun board is not detected. Please verify if it plugged in to USB
                        </div>;
                    }else if(this.state.scenarioState === 'ready'){
                        hwStatus = <div>
                            <button  onClick={this.startScenario}>Start</button>
                        </div>;
                    } else if(this.state.scenarioState === 'idle'){
                        hwStatus = <div>
                            <button onClick={this.stopScenario}>Stop</button>
                        </div>;
                    }
                }else{
                    hwStatus = <div>You have incorrect version of Harrenhal running on your computer.
                        The required version is {harrenhal.HARRENHAL_VER}, but you have {this.state.harrenhal_ver}
                        <br/>
                        Use  <a href={harrenhalDownloadLink}> this link to download and install version {harrenhal.HARRENHAL_VER} </a> once downloaded, start it.
                    </div>;
                }

            }else{
                hwStatus = <div>Connecting to HW bridge application... If you see that message most likely it's not running.
                Use  <a href={harrenhalDownloadLink}> this link to download and install it </a> once downloaded, start it.
                </div>;
            }
        }else{
            hwStatus = <div/>;
        }

        return(
          <div>
            {hwStatus}
            {this.state.sessionLog}
          </div>
        );
    }

    // This method is called by React
    componentWillUnmount() {
        if( this.clearInterval )  // Prevent crash on sign out
            this.clearInterval(this.state.timer);
    }

    // User clicked start scenario button
    startScenario() {
        this.scenarioControl('start');
    }

    // User clicked stop scenario button
    stopScenario() {
        this.scenarioControl('stop');
    }

    // Send scenario control
    scenarioControl(cmd){
        console.log('EditableScenario ' + cmd);
        let req_headers = new Headers();
        req_headers.append('Content-Type', 'application/json');

        let data = {
            command: cmd,
            params: null
        };

        const req_init = {
            method: 'POST',
            headers: req_headers,
            body: JSON.stringify(data),
            mode: 'cors',
            cache: 'default'
        };

        this.doFetch(req_init);
    }

    componentDidUpdate(prevProps, prevState){
        if ( this.props.urls !== prevProps.urls) {
            console.log("URLs  have changed, HW is not configured anymore");
            this.setState(
                {
                    isDriverConfigured: false
                }
            );
        }

        if ( this.state.sess_uuid !== prevState.sess_uuid ) {
            console.log("UUID has changed form %s to %s", prevState.sess_uuid, this.state.sess_uuid);
            if( this.state.sess_uuid && this.state.sess_uuid.length > 10 ){
                this.startDut(this.state.sess_uuid);
                this.props.onDeviceStarted(this.state.sess_uuid);
                this.setState(
                    {
                        sessionLog: "Session " + this.state.sess_uuid + " started"
                    }
                );
            }

            if( prevState.scenarioState === 'running' &&  this.state.scenarioState !== 'running'){
                this.stopDut(prevState.sess_uuid)
                this.props.onDeviceStopped(this.state.sess_uuid)
                this.setState(
                    {
                        sessionLog: this.state.sessionLog + ". Done."
                    }
                );
            }
        }
    }

    // Called every second on a timer
    updateHwStatus() {
        if (this.props.id_token != null){
            let req_headers = new Headers();
            req_headers.append('Content-Type', 'application/json');
            let  data;

            if( this.state.isDriverConfigured){  // Just query the state

                data = {
                    command: 'get_status',
                    params: null
                };

            }else{  // POST configuration parameters
                console.log('Pushing  parameters to local server');

                let if_init_url = this.props.urls.sim_init;
                let if_update_url = this.props.urls.sim_update;
                let client_config = {
                    id_token: this.props.id_token,
                    api_key: params.PENTOS_API_KEY,
                    if_init_url: if_init_url,
                    if_update_url: if_update_url
                };

                data = {
                    command: 'config',
                    params: client_config
                };

            }

            let req_init = {
                method: 'POST',
                headers: req_headers,
                body: JSON.stringify(data),
                mode: 'cors',
                cache: 'default'
            };
            this.doFetch(req_init);
        }
    }

    doFetch(req_init) {
        fetch(HW_DRIVER_URL, req_init)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isDriverConfigured: result.configured,
                        scenarioState: result.state,
                        harrenhal_ver: result.ver,
                        sess_uuid: result.sess_uuid,
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                        console.log('Error talking to HW driver: ' + error);
                    this.setState({
                        isDriverConfigured: false
                    });
                }
            )
    }

    startDut(sess_uuid) {
        console.log("New session started %s", sess_uuid);
        this.dut_control(sess_uuid, 'start');
    }

    stopDut(sess_uuid) {
        console.log("Session ended %s", sess_uuid);
        this.dut_control(sess_uuid, 'stop');
    }

    dut_control(sess_uuid, command){
        let req_headers = new Headers();
        req_headers.append('Content-Type', 'application/json');
        let data = {
            command: command,
            sess_uuid: sess_uuid,
        };
        let req_init = {
            method: 'POST',
            headers: req_headers,
            body: JSON.stringify(data),
            mode: 'cors',
            cache: 'default'
        };
        fetch(this.props.urls.dut_ctrl, req_init)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log('DUT command was sent');
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    console.log('Error talking to DUT driver: ' + error);
                }
            )
    }

}

export default HwStatus;
